import React from "react";
const SvgPoiSchoolHigh = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#0981F9"
        d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12"
      />
      <path
        fill="#FFF"
        d="M4.259 7.055c1.973-1.316 5.066-1.39 7.215-.28v10.997c-.019-.01-.041-.015-.06-.027-.007-.003-.014-.003-.02-.008a.585.585 0 01-.192-.21c-.004-.008-.016-.011-.02-.022-.06-.12-.428-.387-1.392-.545-1.812-.294-4.148.044-4.8.697a.58.58 0 01-.99-.41v-9.71a.58.58 0 01.259-.483zm7.667-.28c2.15-1.11 5.24-1.036 7.215.28a.58.58 0 01.259.483v9.708a.581.581 0 01-.99.41c-.652-.652-2.986-.99-4.8-.696-.963.156-1.331.426-1.391.545-.006.01-.015.015-.021.024a.623.623 0 01-.192.208c-.006.005-.013.005-.02.008-.019.012-.041.018-.06.027zM9.073 13.01h-2.16a.58.58 0 100 1.159h2.16a.58.58 0 100-1.159zm7.28 0h-2.16a.58.58 0 000 1.159h2.16a.58.58 0 100-1.159zm-7.28-1.988h-2.16a.581.581 0 000 1.16h2.16a.58.58 0 10.001-1.16zm7.28 0h-2.16a.58.58 0 000 1.16h2.16a.58.58 0 00.001-1.16zm-7.28-1.988h-2.16a.58.58 0 100 1.16h2.16a.58.58 0 100-1.16zm7.28 0h-2.16a.581.581 0 000 1.16h2.16a.58.58 0 100-1.16z"
      />
    </g>
  </svg>
);
export default SvgPoiSchoolHigh;
